import { IApplicationState } from '../../types/redux';
import { EXPERIMENTAL_LOCATIONS } from '../../constants/experimentalLocations';

// TODO удалить после подтверждения https://jira.cian.tech/browse/OM-912
export function getIsExperimentalLocation(state: IApplicationState): boolean {
  return EXPERIMENTAL_LOCATIONS.includes(state.objectInfo.seoData.location);
}
